//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

import moment from 'moment';

const symbolMap = {
  1: '۱',
  2: '۲',
  3: '۳',
  4: '۴',
  5: '۵',
  6: '۶',
  7: '۷',
  8: '۸',
  9: '۹',
  0: '۰',
};
const numberMap = {
  '۱': '1',
  '۲': '2',
  '۳': '3',
  '۴': '4',
  '۵': '5',
  '۶': '6',
  '۷': '7',
  '۸': '8',
  '۹': '9',
  '۰': '0',
};

export default moment.defineLocale('ps', {
  months: 'جنوري_فبوري_مارچ_اپریل_می_جون_جولای_اگست_سپتمبر_اکتوبر_نومبر_دسمبر'.split('_'),
  monthsShort: 'جنوري_فبوري_مارچ_اپریل_می_جون_جولای_اگست_سپتمبر_اکتوبر_نومبر_دسمبر'.split('_'),
  weekdays: 'یکشنبه_دوشنبه_سه شنبه_چهارشنبه_پنجشنبه_جمعه_شنبه'.split('_'),
  weekdaysShort: 'یکشنبه_دوشنبه_سه شنبه_چهارشنبه_پنجشنبه_جمعه_شنبه'.split('_'),
  weekdaysMin: 'یکشنبه_دوشنبه_سه شنبه_چهارشنبه_پنجشنبه_جمعه_شنبه'.split('_'),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
  },
  meridiemParse: /قبل از ظهر|بعد از ظهر/,
  isPM(input) {
    return /بعد از ظهر/.test(input);
  },
  meridiem(hour) {
    if (hour < 12) {
      return 'قبل از ظهر';
    }
    return 'بعد از ظهر';
  },
  calendar: {
    sameDay: '[امروز ساعت] LT',
    nextDay: '[فردا ساعت] LT',
    nextWeek: 'dddd [ساعت] LT',
    lastDay: '[دیروز ساعت] LT',
    lastWeek: 'dddd [پیش] [ساعت] LT',
    sameElse: 'L',
  },
  relativeTime: {
    future: '%s در',
    past: 'پیش %s',
    s: 'چند ثانیه',
    ss: 'ثانیه d%',
    m: 'یک دقیقه',
    mm: 'دقیقه %d',
    h: 'یک ساعت',
    hh: 'ساعت %d',
    d: 'یک روز',
    dd: 'روز %d',
    M: 'یک ماه',
    MM: 'ماه %d',
    y: 'یک سال',
    yy: 'سال %d',
  },
  preparse(string) {
    return string.replace(/[۰-۹]/g, match => numberMap[match]).replace(/،/g, ',');
  },
  postformat(string) {
    return string.replace(/\d/g, match => symbolMap[match]).replace(/,/g, '،');
  },
  dayOfMonthOrdinalParse: /\d{1,2}م/,
  ordinal: '%dم',
  week: {
    dow: 6, // Saturday is the first day of the week.
    doy: 12, // The week that contains Jan 1st is the first week of the year.
  },
});




// WEBPACK FOOTER //
// ./src/translation/moment/fa.js